import { useEffect, useState } from 'react';

interface Size {
  width: number;
  height: number;
  top: number;
  right: number;
  bottom: number;
  left: number;
  x: number;
  y: number;
}

interface RefObject {
  current: Element | null;
}

const useSize = (ref: RefObject): Size => {
  const [size, setSize] = useState<Size>(null);

  useEffect(() => {
    if (ref.current == null) return;
    const observer = new ResizeObserver(([entry]) =>
      setSize(entry.contentRect)
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [ref]);

  return size;
};

export default useSize;
